import React from 'react';
import { Modal as RModal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import './styles.scss';

const Modal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  placeholder,
  description,
  primaryButtonDisabled,
  children,
  confirmButtonTitle,
  legal,
}) => {
  const { t } = useTranslation();

  return (
    <RModal className="styled-modal" isOpen={isOpen} centered={true}>
      <ModalHeader className="styled-header" toggle={onClose}>
        {placeholder && <span className="styled-modal-placeholder">{placeholder}</span>}
        <div className="styled-modal-title">{title}</div>
      </ModalHeader>
      <ModalBody className="styled-modal-body">
        <p className="styled-description">{description}</p>
        {children}
        <p>{legal}</p>
      </ModalBody>
      <ModalFooter className="styled-modal-footer">
        <button className="modal-button" onClick={onClose}>
          {t('deleteModal.cancelButton')}
        </button>
        <button className={`modal-button primary`} onClick={onConfirm} disabled={primaryButtonDisabled}>
          {confirmButtonTitle ? confirmButtonTitle : t('deleteConfirmModal.deleteButton')}
        </button>
      </ModalFooter>
    </RModal>
  );
};

export default Modal;
